import { API_BASE_URL, API_ENDPOINTS, getHeaders } from '../config/api.config';
import { LoginCredentials, LoginResponse, UserPermissions } from '../../types/auth.types';

export class AuthService {
    async login(credentials: LoginCredentials): Promise<LoginResponse> {
        try {
            const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.AUTH.LOGIN}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify(credentials),
            });

            if (!response.ok) {
                // Parse error response to get detailed error messages
                const errorData = await response.json();
                const error = new Error('Login failed');
                (error as any).response = {
                    status: response.status,
                    data: errorData
                };
                throw error;
            }

            const data: LoginResponse = await response.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    async selectBranch(branchId: number, token: string): Promise<any> {
        try {
            const response = await fetch(`${API_BASE_URL}/select-branch`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({
                    branch_id: branchId,
                    token: token
                }),
            });

            if (!response.ok) {
                throw new Error('Branch selection failed');
            }

            const data = await response.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getUserPermissions(token: string): Promise<UserPermissions> {
    try {
        const url = `${API_BASE_URL}/user/permissions`;
        console.log('[AuthService] Fetching permissions from:', url);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                ...getHeaders(),
                'Authorization': `Bearer ${token}`,
            },
        });

        console.log('[AuthService] Permissions response status:', response.status);
        if (!response.ok) {
            const errorText = await response.text();
            console.error('[AuthService] Permissions fetch failed:', response.status, errorText);
            throw new Error('Failed to fetch user permissions');
        }

        const data: UserPermissions = await response.json();
        console.log('[AuthService] Permissions received:', data, 'Keys count:', Object.keys(data || {}).length);
        return data;
    } catch (error) {
        console.error('[AuthService] Error fetching user permissions:', error);
        throw error;
    }
}

    // Add other auth-related methods here (logout, refresh token, etc.)
}

// Export a singleton instance
export const authService = new AuthService();
